@for (error of errorKeys; track error) {
  @if (control && (control.touched || control.dirty) && control.errors && control.errors[error]) {
    <div
      class="invalid-feedback d-block"
      >
      @if (errorOverride[error]) {
        {{errorOverride[error]}}
      } @else {
        {{control.errors[error]}}
      }
    </div>
  }
}
